import styled from 'styled-components'

import { COLOR } from '@/shared/constant/color'

export const BtnW92H44 = styled.div`
  width: 92px;
  height: 44px;
  line-height: 44px;
  background: ${COLOR.point1};
  text-align: center;
  border-radius: 30px;
  margin: 16px 13px 16px 14px;
  border: none;

  > a {
    width: 92px;
    font-family: NanumSquareNeoHeavy, sans-serif;
    display: inline-block;
    font-size: 18px;
    line-height: 44px;
    color: white;
  }
`
export const BtnW172H44 = styled.div`
  display: inline-block;
  width: 172px;
  height: 44px;
  line-height: 44px;
  border-radius: 30px;
  margin: 16px 0;
  text-align: center;
  border: 2px solid ${(props) => (props.color === COLOR.point1 ? COLOR.point1 : 'none')};
  background: ${(props) => (props.color === COLOR.point1 ? 'none' : COLOR.point1)};
  color: ${(props) => props.color};

  cursor: pointer;

  &:hover,
  &:active {
    -webkit-tap-highlight-color: transparent;
    background-color: ${COLOR.point4};
  }
`
export const ModalBtn = styled.div<{ bgColor: string }>`
  cursor: pointer;
  width: 132px;
  height: 48px;
  text-align: center;
  border-radius: 30px;
  background: ${(props) => props.bgColor};
  margin: 16px auto 28px auto;
  border: none;
  line-height: 48px;

  > span {
    font-family: NotoSansBold, sans-serif;
    font-size: 16px;
    color: ${COLOR.white};
  }
`

export const CustomBtn = styled.button<{
  fontSize?: string
  fontFamily?: string
  width?: string
  height?: string
  bgColor?: string
  borderColor?: string
  color?: string
  borderRadius?: string
  marginTop?: string
}>`
  display: flex;
  justify-content: center;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  border: ${(props) => (props.borderColor !== undefined ? `1px solid ${props.borderColor}` : 'none')};
  margin: ${(props) => `${props.marginTop} auto 0 auto`};
  background: ${(props) => (props.disabled ? COLOR.blueGray1 : props.bgColor)};
  color: ${(props) => props.color};
  padding: 0;
  border-radius: ${(props) => props.borderRadius};
  pointer-events: ${(props) => props.bgColor === COLOR.gray30 && 'none'};

  &.health_btn_mo {
    > img {
      width: 16px;
      height: 16px;
      margin: 15px 5px 15px 0;
      display: block;
    }
  }

  &.health_btn_pc {
    > img {
      width: 16px;
      height: 16px;
      margin: 20px 5px 20px 0;
      display: block;
    }
  }

  > span,
  > a {
    text-align: center;
    color: ${(props) => props.color};
    line-height: ${(props) => props.height};
    font-family: ${(props) => props.fontFamily};
    font-size: ${(props) => props.fontSize};
  }
`
